 
import './App.css';  
import { useState } from 'react'; 
import 'bootstrap/dist/css/bootstrap.min.css'; 
import LoginPage from './components/LoginPage';
import ResultsPage from './components/AssignmentPages/ResultPage';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Menu from './components/Menu';
import LiveTrafficStatus from './components/LiveTraffic/LiveTrafficStatus';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const savedLoginStatus = localStorage.getItem('isLoggedIn');
    return savedLoginStatus === 'true';  
  });
 
  const [isAdmin, setisAdmin] = useState(() => {
    const savedisAdminStatus = localStorage.getItem('isAdmin');
    return savedisAdminStatus === 'true'; 
  });

  const handleLoginSuccess = (AccountID,isAdmin) => {
    setIsLoggedIn(true); 
    setisAdmin(isAdmin);
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('AccountID', AccountID);  
    localStorage.setItem('isAdmin', isAdmin);  
  };
  
return (
  <Router basename={window.config.basename} >
      <div className="App">  
        <Routes> 
          <Route 
            path="/" 
            element={<LoginPage onLoginSuccess={handleLoginSuccess} />} 
          />

          {/* <Route path="/menu" 
            element={isLoggedIn ? <Menu /> : <Navigate to="/" replace />} 
          />  */}

          <Route path="/results" 
            element={isLoggedIn ? <ResultsPage /> : <Navigate to="/" replace />} 
          />

          <Route path="/livetrafficstatus" 
            element={isLoggedIn && isAdmin  ? <LiveTrafficStatus /> : <Navigate to="/" replace />} 
          />
          
         <Route path="*" element={<p style={{textAlign: 'center', marginTop: '50px'}}>404: Page Not Found</p>} />

        </Routes>
      </div>
    </Router>
);
}

export default App;
